import React, { useEffect } from "react"
import BruksklasseSearch from "./SearchOptions"

import "@nvdb-rapport/shared/src/styled/global/reset.css"
import "@nvdb-rapport/shared/src/styled/global/global.css"
import { apiPath } from "../api"

import { UIModel, UIAction } from "../store/ui"
import { ArbeidModel, ArbeidAction } from "../store/arbeid"
import { PubliseringModel, PubliseringAction } from "../store/publisering"

// Ensures correct type of env-variables
declare var process: {
  env: {
    NODE_ENV: string
    REACT_APP_API_PATH_LOCAL: string
    REACT_APP_API_PATH_ATLAS_UTV: string
    REACT_APP_API_PATH_ATLAS_ATM: string
    REACT_APP_API_PATH_ATLAS_PROD: string
  }
}

interface Props {
  arbeidState: ArbeidModel
  arbeidDispatch: React.Dispatch<ArbeidAction>
  uiState: UIModel
  uiDispatch: React.Dispatch<UIAction>
  publiseringState: PubliseringModel
  publiseringDispatch: React.Dispatch<PubliseringAction>
}

function App({
  arbeidDispatch,
  arbeidState,
  uiDispatch,
  uiState,
  publiseringDispatch,
  publiseringState,
}: Props) {
  useEffect(() => {
    console.log(
      "Running in " +
        process.env.NODE_ENV +
        " mode with REST API server " +
        apiPath
    )
  }, [])

  return (
    <BruksklasseSearch
      uiState={uiState}
      uiDispatch={uiDispatch}
      arbeidDispatch={arbeidDispatch}
      arbeidState={arbeidState}
      publiseringDispatch={publiseringDispatch}
      publiseringState={publiseringState}
    />
  )
}

export default App
